import React, { ChangeEventHandler, Ref } from "react";
import { FieldError } from "react-hook-form";

import { Search } from "shared/assets/icons";
import { IFieldLink } from "shared/types";

import { StyledInputField, InputFieldWrapper } from "../styles";
import { StyledSearchFieldButton } from "./style";
import { FieldWrapper, FieldWrapperProps } from "../FieldWrapper";
import { Icon } from "shared/styles";

interface SearchFieldProps extends FieldWrapperProps {
  registerRef?: Ref<HTMLInputElement>;
  fieldLink?: IFieldLink;
  error?: FieldError | null;
  hasButton?: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement>;
}

export const SearchField: React.FC<SearchFieldProps> = ({
  name,
  registerRef,
  error,
  hasButton,
  onChange,
  ...props
}) => {
  return (
    <FieldWrapper name={name} error={error} {...props}>
      <InputFieldWrapper error={!!error}>
        <StyledInputField type="text" name={name} id={name} ref={registerRef} onChange={onChange} />
        {hasButton && (
          <StyledSearchFieldButton aria-label="Search" type="submit" size="xs">
            <Icon as={Search} size="l" />
          </StyledSearchFieldButton>
        )}
      </InputFieldWrapper>
    </FieldWrapper>
  );
};
